export enum ResourceType {
  CONSUMABLE = 'consumable',
  TOOL = 'tool',
  POWER_TOOL = 'power_tool',
  VEHICLE = 'vehicle',
  MAN_POWER = 'man_power'
}

export enum ResourceUnit {
  NA = 'n/a',
  UNIT = 'unit',
  HOUR = 'hour',
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
  KILOGRAM = 'kilogram',
  TON = 'ton',
  METER = 'meter',
  KILOMETER = 'kilometer',
  SQUARE_METER = 'square_meter',
  SQUARE_KILOMETER = 'square_kilometer',
  HECTARE = 'hectare',
  ACRE = 'acre',
  CUBIC_METER = 'cubic_meter',
  CUBIC_KILOMETER = 'cubic_kilometer',
  LITRE = 'litre',
  ALQUEIRE = 'alqueire'
}

export const EQUIPMENT_TYPES: ResourceType[] = [
  ResourceType.VEHICLE,
  ResourceType.TOOL,
  ResourceType.POWER_TOOL
];

export const RESOURCE_TYPE_LABEL_KEYS: Record<string, string> = {
  [ResourceType.VEHICLE]: 'typeVehicle',
  [ResourceType.TOOL]: 'typeTool',
  [ResourceType.POWER_TOOL]: 'typePowerTool',
  [ResourceType.CONSUMABLE]: 'typeConsumable',
  [ResourceType.MAN_POWER]: 'typeManPower'
};

export const RESOURCE_UNIT_LABEL_KEYS: Record<string, string> = {
  [ResourceUnit.NA]: 'unitNA',
  [ResourceUnit.UNIT]: 'unit_generic',
  [ResourceUnit.HOUR]: 'hour',
  [ResourceUnit.DAY]: 'day',
  [ResourceUnit.MONTH]: 'month',
  [ResourceUnit.YEAR]: 'year',
  [ResourceUnit.KILOGRAM]: 'kilogram',
  [ResourceUnit.TON]: 'ton',
  [ResourceUnit.METER]: 'meter',
  [ResourceUnit.KILOMETER]: 'kilometer',
  [ResourceUnit.SQUARE_METER]: 'squareMeter',
  [ResourceUnit.SQUARE_KILOMETER]: 'squareKilometer',
  [ResourceUnit.HECTARE]: 'hectare',
  [ResourceUnit.ACRE]: 'acre',
  [ResourceUnit.CUBIC_METER]: 'cubicMeter',
  [ResourceUnit.CUBIC_KILOMETER]: 'cubicKilometer',
  [ResourceUnit.LITRE]: 'litre',
  [ResourceUnit.ALQUEIRE]: 'alqueire'
};

export enum TaxValue {
  VAT_6 = '6',
  VAT_13 = '13',
  VAT_23 = '23'
}

export interface ResourcePricingOption {
  unit: string;
  unit_price: number;
}

export interface ResourcePricingUpdate {
  pricing_id?: string;
  current_unit?: string;
  unit: string;
  unit_price: string | number;
}

export interface EquipmentData {
  id?: string;
  id_pricing?: string;
  name: string;
  brand: string;
  model: string;
  serial_number: string;
  power: string;
  purchase_date: string;
  acquisition_value: string;
  unit: string;
  unit_price: string;
  description?: string;
  type?: string;
}

export interface EquipmentDataDTO {
  name: string;
  description?: string;
  type: ResourceType;
  pricing_options: ResourcePricingOption[];
  metadata: {
    brand?: string;
    model?: string;
    serial_number?: string;
    power?: string;
    purchase_date?: string;
    acquisition_value?: string;
  };
}

export interface EquipmentUpdateData {
  name: string;
  description?: string;
  pricing: ResourcePricingUpdate;
  metadata: {
    brand?: string;
    model?: string;
    serial_number?: string;
    power?: string;
    purchase_date?: string;
    acquisition_value?: string;
  };
}

export interface ConsumableData {
  id?: string;
  id_pricing?: string;
  name: string;
  brand: string;
  reference: string;
  purchase_date: string;
  acquisition_value: string;
  unit: string;
  unit_price: string;
  description?: string;
}

export interface ConsumableDataDTO {
  name: string;
  description?: string;
  type: ResourceType;
  pricing_options: ResourcePricingOption[];
  metadata: {
    brand?: string;
    reference?: string;
    purchase_date?: string;
    acquisition_value?: string;
  };
}

export interface ConsumableUpdateData {
  name: string;
  description?: string;
  pricing: ResourcePricingUpdate;
  metadata: {
    brand?: string;
    reference?: string;
    purchase_date?: string;
    acquisition_value?: string;
  };
}

export interface CollaboratorData {
  id?: string;
  id_pricing?: string;
  name: string;
  description?: string;
  job: string;
  birth_date: string;
  unit: string;
  unit_price: string;
}

export interface CollaboratorDataDTO {
  name: string;
  description?: string;
  type: ResourceType;
  pricing_options: ResourcePricingOption[];
  metadata: {
    job?: string;
    birth_date?: string;
  };
}

export interface CollaboratorUpdateData {
  name: string;
  description?: string;
  pricing: ResourcePricingUpdate;
  metadata: {
    job?: string;
    birth_date?: string;
  };
}

export interface ServiceData {
  id?: string;
  id_variant?: string;
  id_price?: string;
  category?: string;
  sub_category?: string;
  name: string;
  description: string;
  unit: string;
  unit_price: string;
  tax_value: string;
  handle?: string;
}

export interface ServiceDataDTO {
  title: string;
  status: string;
  description: string;
  handle: string;
  options: Array<{
    title: string;
    values: string[];
  }>;
  categories: Array<{ id: string }>;
  variants: Array<{
    title: string;
    prices: Array<{
      currency_code: string;
      amount: number;
    }>;
    manage_inventory: boolean;
    options: {
      [key: string]: string;
    };
    metadata: {
      unit: string;
      tax_value: string;
    };
  }>;
}
